import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import BackComponent from 'screens/back';
import { Table, Pagination, Tooltip, Input, CheckboxTable, Modal } from 'components';
import { TrashIcon, EditIcon, CleanIcon, AddWhiteIcon, TrashWhiteIcon, ConfirmIcon, StarIcon, ViewIcon } from 'assets/icons';
import { Globals, checkPermission, Constants } from 'utils';
import { OperatorService } from 'services';
import ModalCreateOperator from './create-operator';
import ModalView from './modal-view';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const INITIAL_STATE = {
	search: ''
}

class Operators extends React.Component<Props> {

	timer: any = undefined;

	state = {
		form: INITIAL_STATE,
		page: 1,
		last_page: 1,
		data: [],
		header: [
			'Nombre',
			'Cédula',
			'Teléfono',
			'Dirección',
			'Persona de Contacto',
			'Acciones'
		],
		visible: false,
		item: null,
		services: [],
		visible_confirm: false, 
		visible_delete: false,
		visible_bulk_confirm: false, 
		visible_bulk_delete: false,
		visible_view: false,
		document_types: []
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Operarios',
				onBack: null
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});

		this.load();
		this.loadServiceTypes();
	}

	loadServiceTypes = async () => {
		const res: any = await OperatorService.admin.getServices({
			withoutLoading: true
		});
		this.setState({
			services: res.services,
			document_types: res.document_types.filter((i: any) => i.id != Constants.DOCUMENT_TYPES.G)
		});
	}

	load = async (withoutLoading: boolean = false) => {
		const res: any = await OperatorService.admin.get({
			withoutLoading,
			page: this.state.page,
			...this.state.form,
		});
		this.setState({
			data: res.operators.rows,
			last_page: res.operators.count
		});
	}

	reset = () => {
		this.setState({
			form: INITIAL_STATE,
			page: 1
		},() => this.load(true));
	}

	edit = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			visible: true,
			item
		});
	}

	view = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			visible_view: true,
			item
		});
	}

	confirmDelete = (e: any, item: any) => {
		e.preventDefault();
		this.setState({
			visible_confirm: true,
			item
		});
	}

	delete = async () => {
		const item: any = this.state.item;
		await OperatorService.admin.delete({
			user_id: item.id
		});
		await this.setState({
			visible_delete: true,
			visible_confirm: false,
			item: null
		});
		this.load(true);
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	bulkDelete = async () => {
		await OperatorService.admin.bulkDelete({
			users_id: this.state.data.filter((i: any) => i.active).map((i: any) => i.id),
		});
		await this.setState({
			visible_bulk_delete: true,
			visible_bulk_confirm: false
		});
		this.load(true);
	}

	confirmBulkDelete = () => {
		this.setState({
			visible_bulk_confirm: true
		});
	}

	setActive = (index: number) => {
		let data: any = [...this.state.data];
		data[index].active = !data[index].active;
		this.setState({
			data
		});
	}

	setAllActive = () => {
		let data: any = [...this.state.data];
		if (data.filter((i: any) => i.active).length == data.length) {
			data.map((i: any) => {
				i.active = false;
				return i;
			});
		}
		else {
			data.map((i: any) => {
				if (!i.active) {
					i.active = true;
				}
				return i;
			});
		}
		this.setState({
			data
		});
	}

	add = () => {
		this.setState({
			visible: true
		});
	}

	onClose = () => {
		this.setState({
			visible: false,
			item: null
		},() => this.load(true));
	}

	onCloseConfirm = () => {
		this.setState({
			visible_confirm: false
		});
	}

	onCloseDelete = () => {
		this.setState({
			visible_delete: false
		});
	}

	onCloseBulkDelete = () => {
		this.setState({
			visible_bulk_delete: false
		});
	}

	onCloseBulkConfirm = () => {
		this.setState({
			visible_bulk_confirm: false
		});
	}

	onCloseView = () => {
		this.setState({
			visible_view: false,
			item: null
		});
	}
	
	render() {
		const { visible, visible_confirm, visible_delete, visible_bulk_confirm, visible_bulk_delete, visible_view } = this.state;

		return (
			<div id="operators">
				<Modal
		          className="modal-create-operator"
		          visible={ visible }
		          title="Datos del Operario"
		          onClose={ () => this.onClose() }
		        >
		          <ModalCreateOperator
		          	services={ this.state.services }
		          	item={ this.state.item }
		          	document_types={ this.state.document_types }
		            onClose={ () => this.onClose() } />
		      	</Modal>

		      	<Modal
		          className="modal-view-operator"
		          visible={ visible_view }
		          title="Datos Talento Servizi"
		          centered
		          onClose={ () => this.onCloseView() }
		        >
		        	<ModalView
		        		onClose={ () => this.onCloseView() }
		        		item={ this.state.item }
		        	/>
		      	</Modal>

		      	<Modal
		          className="modal-moderators-confirm-delete"
		          visible={ visible_confirm }
		          title=""
		          centered
		          onClose={ () => this.onCloseConfirm() }
		        >
					<div id="modal-moderators-confirm-delete">
						<img src={ ConfirmIcon } />
						<h3>¿Está seguro de eliminar al operario?</h3>
						<div className="row">
							<div className="col-6 text-center">
								<button className="btn" onClick={ () => this.delete() }>
									Aceptar
								</button>
							</div>
							<div className="col-6 text-center">
								<button className="btn btn-cancel" onClick={ () => {
									this.setState({
										visible_confirm: false,
										item: null
									});
								} }>
									Cancelar
								</button>
							</div>
						</div>
					</div>
		      	</Modal>

		      	<Modal
		          className="modal-moderators-message-delete"
		          visible={ visible_delete }
		          title=""
		          centered
		          onClose={ () => this.onCloseDelete() }
		        >
					<div id="modal-moderators-message-delete">
						<img src={ StarIcon } />
						<h3>Se ha eliminado con éxito</h3>
					</div>
		      	</Modal>

		      	<Modal
		          className="modal-moderators-confirm-delete"
		          visible={ visible_bulk_confirm }
		          title=""
		          centered
		          onClose={ () => this.onCloseBulkConfirm() }
		        >
					<div id="modal-moderators-confirm-delete">
						<img src={ ConfirmIcon } />
						<h3>¿Está seguro de eliminar los operarios seleccionados?</h3>
						<div className="row">
							<div className="col-6 text-center">
								<button className="btn" onClick={ () => this.bulkDelete() }>
									Aceptar
								</button>
							</div>
							<div className="col-6 text-center">
								<button className="btn btn-cancel" onClick={ () => {
									this.setState({
										visible_bulk_confirm: false
									});
								} }>
									Cancelar
								</button>
							</div>
						</div>
					</div>
		      	</Modal>

		      	<Modal
		          className="modal-moderators-message-delete"
		          visible={ visible_bulk_delete }
		          title=""
		          centered
		          onClose={ () => this.onCloseBulkDelete() }
		        >
					<div id="modal-moderators-message-delete">
						<img src={ StarIcon } />
						<h3>Se han eliminado con éxito</h3>
					</div>
		      	</Modal>

				<BackComponent />

				<div className="row row-filter">
					<div className="col-md-8">
						<div className="row">
							<div className="col-md-5">
								<Input
									searchLeft
									value={ this.state.form.search }
									name="search"
									placeholder="Nombre"
									className="input-table"
									onSubmit={ () => this.load() }
									onChange={ (e: any) => {
										clearTimeout(this.timer);
										this.timer = setTimeout(() => {
											this.load(true);
										},1000);
										this.change(e); 
									} } />
							</div>
							<div className="col-md-2">
								{
									this.state.form != INITIAL_STATE && (
										<button className="btn btn-clean" onClick={ () => this.reset() }>
											<img src={ CleanIcon } />
										</button>
									)
								}
							</div>
						</div>
					</div>
					<div className="col-md-4 text-right">
						{
							checkPermission(Constants.MODULES.OPERATORS,'delete') && this.state.data.filter((i: any) => i.active).length > 0 && (
								<button className="btn btn-delete" onClick={ () => this.confirmBulkDelete() }>
									<img src={ TrashWhiteIcon } />
									Eliminar
								</button>
							)
						}
						{
							checkPermission(Constants.MODULES.OPERATORS,'write') && (
								<button className="btn btn-add" onClick={ () => this.add() }>
									<img src={ AddWhiteIcon } />
								</button>
							)
						}
					</div>
				</div>

				<Table data={ this.state.data.length } header={ this.state.header } childrenHeader={
					<th>
						{
							checkPermission(Constants.MODULES.OPERATORS,'delete') && (
								<CheckboxTable 
									active={ this.state.data.filter((i: any) => i.active).length == this.state.data.length } 
									onClick={ () => this.setAllActive() } />
							)
						}
					</th>
				}>
					{ this.state.data.map((i: any,index: number) => {
						return (
							<tr key={ index }>
								<td>
									{
										checkPermission(Constants.MODULES.OPERATORS,'delete') && (
											<CheckboxTable 
												active={ i.active } 
												onClick={ () => this.setActive(index) } />
										)
									}
								</td>
								<td>{ i.full_name }</td>
								<td style={{ whiteSpace: 'nowrap' }}>{ i.full_document }</td>
								<td>{ i.phone }</td>
								<td>{ i.address }</td>
								<td>{ i.contact_person }</td>
								<td>
									<Tooltip title="Ver">
										<a className="link-icon" href="#" onClick={ (e: any) => this.view(e,i) }>
											<img src={ ViewIcon } />
										</a>
									</Tooltip>
									{
										checkPermission(Constants.MODULES.OPERATORS,'write') && (
											<Tooltip title="Editar">
												<a className="link-icon" href="#" onClick={ (e: any) => this.edit(e,i) }>
													<img src={ EditIcon } />
												</a>
											</Tooltip>
										)
									}
									{
										checkPermission(Constants.MODULES.OPERATORS,'delete') && (
											<Tooltip title="Eliminar">
												<a className="link-icon" href="#" onClick={ (e: any) => this.confirmDelete(e,i) }>
													<img src={ TrashIcon } />
												</a>
											</Tooltip>
										)
									}
								</td>
							</tr>
						)
					}) }
				</Table>

				<Pagination 
					pages={ this.state.last_page } 
					active={ this.state.page }
					onChange={ async (page: number) => {
						await this.setState({
							page: page
						});
						this.load();
					} } />
			</div>
		)
	}
}

export default connect()(Operators);